import {PartialWorkout} from '../Models/PartialWorkout';
import {Distance} from '../Domain/Distance';
import {Duration} from '../Domain/Duration';
import {Speed} from '../Domain/Speed';
import {lazy} from '../Support/lazy';

export class StatisticsProvider {
    private constructor(private partialWorkouts: PartialWorkout[]) {}

    public static create(partialWorkouts: PartialWorkout[]): StatisticsProvider {
        return new StatisticsProvider(partialWorkouts);
    }

    @lazy()
    public get totalDistance(): Distance {
        return this.partialWorkouts.reduce((sumOverall, partialWorkout) => {
            const distance: Distance = partialWorkout.workout_part_results.reduce(
                (sumWorkout, result) => sumWorkout.add(result.traveled_distance),
                Distance.fromMeters(0),
            );
            return sumOverall.add(distance);
        }, Distance.fromMeters(0));
    }

    @lazy()
    public get totalDuration(): Duration {
        return this.partialWorkouts.reduce((sumOverall, partialWorkout) => {
            const duration: Duration = partialWorkout.workout_part_results.reduce(
                (sumWorkout, result) => sumWorkout.add(result.elapsed_time),
                Duration.fromMilliseconds(0),
            );
            return sumOverall.add(duration);
        }, Duration.fromMilliseconds(0));
    }

    @lazy()
    public get averageSpeed(): Speed {
        return Speed.fromDistanceAndDuration(this.totalDistance, this.totalDuration);
    }
}
